/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Mitra_CtaInputs */

const en_cp_p_mitra_cta = /** @type {(inputs: Cp_P_Mitra_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply for an MoU`)
};

const id_cp_p_mitra_cta = /** @type {(inputs: Cp_P_Mitra_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajukan MoU`)
};

/**
* | output |
* | --- |
* | "Apply for an MoU" |
*
* @param {Cp_P_Mitra_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_mitra_cta = /** @type {((inputs?: Cp_P_Mitra_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Mitra_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_mitra_cta(inputs)
	return en_cp_p_mitra_cta(inputs)
});